import React from 'react'
import { Header, Container, SimplePageHeader, DashboardHeader } from '../../components'
import { Sidebar } from './sidebar'
import { useViewport, viewportBreakpoint } from '../../utils'
import { Icon } from '@fluentui/react/lib/Icon'
import auth from '../../utils/auth'

const MapLayers = () => <Icon iconName="MapLayers" className="ms-MapLayers text-xl" />;
const FabricUserFolder = () => <Icon iconName="FabricUserFolder" className="ms-FabricUserFolder text-xl" />;
const Paste = () => <Icon iconName="Paste" className="ms-Paste text-xl" />;
const PenWorkspace = () => <Icon iconName="PenWorkspace" className="ms-PenWorkspace text-xl" />;
const Media = () => <Icon iconName="Media" className="ms-Media text-xl" />;
const OpenFile = () => <Icon iconName="OpenFile" className="ms-OpenFile text-xl" />;
const Settings = () => <Icon iconName="Settings" className="ms-Settings text-xl" />;
const DoubleBookmark = () => <Icon iconName="DoubleBookmark" className="ms-DoubleBookmark text-xl" />;
const ChangeEntitlements = () => <Icon iconName="ChangeEntitlements" className="ms-ChangeEntitlements text-xl" />;

const DashboardLayout = ({title = 'Dashboard', children, mobileNav, addButton}) => {
  const [opened, setOpened] = React.useState(false)
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const isTablet = width >= viewportBreakpoint.tablet && width < viewportBreakpoint.desktop
  const { isOfficial, isVerified, isUser, isSuperadmin } = auth()

  const role = isOfficial ? 'official' : isVerified ? 'verified' : isUser ? 'user' : isSuperadmin ? 'superadmin' : ''

  const menu = [
    {
      name: 'dashboard',
      label: 'Dashboard',
      route: '/dashboard',
      icon: <MapLayers />,
      roles: ['official', 'superadmin'],
      exact: true
    },
    {
      name: 'profile',
      label: role === 'official' ? 'Profil' : 'My Profile',
      route: '/dashboard/profile',
      icon: <FabricUserFolder />,
      roles: ['official', 'verified', 'user']
    },
    {
      name: 'resources',
      label: 'Produk',
      route: '/dashboard/resources',
      icon: <Media />,
      roles: ['official']
    },
    {
      name: 'events',
      label: 'Acara',
      route: '/dashboard/events',
      icon: <PenWorkspace />,
      roles: ['official'],
      // unread: true
    },
    {
      name: 'programs',
      label: 'Inisiatif',
      route: '/dashboard/programs',
      icon: <Paste />,
      roles: ['official']
    },
    {
      name: 'message',
      label: 'Kolaborasi',
      route: '/dashboard/message',
      icon: <ChangeEntitlements />,
      roles: ['official']
    },
    {
      name: 'blog',
      label: 'Blog',
      route: '/dashboard/blog',
      icon: <OpenFile />,
      roles: ['official']
    },
    {
      name: 'bookmarks',
      label: 'Bookmarks',
      route: '/dashboard/bookmarks',
      icon: <DoubleBookmark />,
      roles: ['official', 'verified', 'user']
    },
    {
      name: 'tickets',
      label: 'Event Tickets',
      route: '/dashboard/tickets',
      icon: <Paste />,
      roles: ['verified']
    },
    {
      name: 'visibility',
      label: 'Visibility Default',
      route: '/dashboard/visibility',
      icon: <Settings />,
      roles: ['official']
    },
    {
      name: 'settings',
      label: 'Account Settings',
      route: '/dashboard/settings',
      icon: <Settings />,
      roles: ['official', 'verified', 'user']
    },
  ]

  const handleBack = () => {
    setOpened(true)
  }

  return isMobile || isTablet ? (

    // MOBILE
    <div>
      <div style={{background:'#fff'}}>
        <Header role={role} noDropdown />
      </div>

      {/* <SimplePageHeader noPadding/> */}
      <div style={{ height: 77 }}></div>

      <DashboardHeader
        handleBack={handleBack}
        addButton={addButton}
      >
        {title}
      </DashboardHeader>

      { mobileNav && mobileNav }

      <Container>
        {children}
      </Container>

      {/* Dashboard Menu */}
      {
        opened &&
        <div className="w-full h-screen fixed left-0 top-0 bg-white" style={{zIndex: 700}}>
          <SimplePageHeader noPadding/>
          <Sidebar menu={menu.filter(m => m.roles.indexOf(role) > -1)} />
        </div>
      }
    </div>
  ) : (

    // DESKTOP
    <div style={{background: '#f5f5f5'}}>
      <div style={{background:'#fff'}}>
        <Header role={role} noDropdown />
      </div>
      <SimplePageHeader noPadding/>
      <div className="min-h-screen h-full">
        <Container className="py-10">
          <div className="flex flex-wrap -mx-4">
            <div className="w-3/12">
              <Sidebar menu={menu.filter(m => m.roles.indexOf(role) > -1)} />
            </div>
            <div className="w-9/12 -ml-4" style={{maxWidth: '900px'}}>
              <div className="rounded bg-white p-8">
                {children}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export { DashboardLayout }
